export const moneyMaskPrefixedWithoutDecimal = 'separator';
